import styled from 'styled-components'

export const ModalBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-size: 15px;
  font-weight: 400;
  padding: 20px;
  max-width: 400px;
`

export const RowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
`
